import { render, staticRenderFns } from "./RoleDisplay.vue?vue&type=template&id=1c3d1bf9&scoped=true"
import script from "./RoleDisplay.vue?vue&type=script&lang=js"
export * from "./RoleDisplay.vue?vue&type=script&lang=js"
import style0 from "./RoleDisplay.vue?vue&type=style&index=0&id=1c3d1bf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d1bf9",
  null
  
)

export default component.exports